"use client";

import { GoogleTagManager } from "@next/third-parties/google";
import { useSyncExternalStore } from "react";
import {
  isTagManagerDocument,
  subscribeToTagManagerDocument,
} from "@/lib/analytics/tag-manager-document";

function isServerTagManagerDocument(): boolean {
  return false;
}

export function SiteGoogleTagManager({ gtmId }: { gtmId: string }) {
  const isMeasured = useSyncExternalStore(
    subscribeToTagManagerDocument,
    isTagManagerDocument,
    isServerTagManagerDocument,
  );

  return isMeasured ? <GoogleTagManager gtmId={gtmId} /> : null;
}
